module.exports = __webpack_public_path__ + "img/cap.81fbe6ce.jpg";